























import Component, { mixins } from 'vue-class-component';
import Message from '@/components/message.vue';
import MessageMixin from '@/components/message-mixin';
import * as Logger from 'js-logger';
import { ISysVar } from '@/models/sysvar';
import SysvarEdit from '@/components/sysvar/sysvar-edit.vue';

const log = Logger.get('sysvar/main');

@Component({
  components: { Message, SysvarEdit }
})
export default class Sysvars extends mixins(MessageMixin) {
  sysvars: ISysVar[] = [];

  async mounted() {
    try {
      this.setMessage('pending', 'One sec, fetching variables...');
      this.sysvars = await this.$api.get('/api/sysvar') as ISysVar[];
      this.message = null;
    } catch (e) {
      this.setMessage('error', `Error fetching system variables`);
      log.error('Error fetching sysvars', e);
    }
  }
}
